import { create } from 'zustand';
import type { BrandingConfig } from '@shared/types';

interface BrandingState {
  branding: BrandingConfig | null;
  setBranding: (branding: BrandingConfig) => void;
}

export const useBrandingStore = create<BrandingState>((set) => ({
  branding: null,
  setBranding: (branding) => set({ branding }),
}));
